import ArrowsVertical from '@deliveroo/icon-set/react/ArrowsVertical';
import Carrot from '@deliveroo/icon-set/react/Carrot';
import ChevronDown from '@deliveroo/icon-set/react/ChevronDown';
import ChevronUp from '@deliveroo/icon-set/react/ChevronUp';
import Clock from '@deliveroo/icon-set/react/Clock';
import Deliveroo from '@deliveroo/icon-set/react/Deliveroo';
import GlobeLeaf from '@deliveroo/icon-set/react/GlobeLeaf';
import MagnifyingGlass from '@deliveroo/icon-set/react/MagnifyingGlass';
import Pin from '@deliveroo/icon-set/react/Pin';
import Recycle from '@deliveroo/icon-set/react/Recycle';
import StarFill from '@deliveroo/icon-set/react/StarFill';
import Tag from '@deliveroo/icon-set/react/Tag';

const supportedIconMap = {
  'arrows-vertical': ArrowsVertical,
  carrot: Carrot,
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  clock: Clock,
  deliveroo: Deliveroo,
  'globe-leaf': GlobeLeaf,
  'magnifying-glass': MagnifyingGlass,
  pin: Pin,
  recycle: Recycle,
  'star-fill': StarFill,
  tag: Tag,
};

export default supportedIconMap;
